import {Component, OnInit} from '@angular/core';
import {MatDialogRef, MAT_DIALOG_DATA} from "@angular/material/dialog";
import {MatDialog, MatDialogConfig} from '@angular/material/dialog';

@Component({
  selector: 'app-help-dialog',
  templateUrl: './help-dialog.component.html',
  styleUrls: ['./help-dialog.component.scss']
})
export class HelpDialogComponent {

  constructor(private dialogRef: MatDialogRef<HelpDialogComponent>) {
    this.defaultFilter();
  }

  defaultFilter() {
    let Element = (<HTMLScriptElement[]><any>document.getElementsByTagName('mat-dialog-container'))[0];
    Element.style.padding = '0';
    Element.style.maxHeight = (window.innerHeight - window.innerHeight / 8).toString() + 'px';
    document.body.style.overflow = 'hidden';
  }

  closeDialog() {
    this.dialogRef.close();
  }

}
